import { CountdownTimer } from "./components/Timer";

import "./styles/toppage.css";
import "./styles/rsvp.css";
import "./styles/details.css";
import "./styles/navigation.css";
import "./styles/registry.css";
import "./styles/media.css";

import TopPage, { Welcome } from "./components/TopPage";
import RSVP from "./components/RSVP";
import Details from "./components/Details";
import ScrollAnimation from "./components/Animation";
import Registry from "./components/Registry";
import { useEffect, useState } from "react";
import Preloader from "./components/Preloader";
import { ErrorMessage } from "./components/Error";

function App() {
  const [loading, setLoading] = useState(true);
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    const handleLoad = () => {
      setLoading(false);
    };

    // If page already loaded (fast refresh case)
    if (document.readyState === "complete") {
      handleLoad();
    } else {
      window.addEventListener("load", handleLoad);
    }

    return () => window.removeEventListener("load", handleLoad);
  }, []);

  // wait for fade-out animation before unmounting
  useEffect(() => {
    if (!loading) {
      const fadeTimer = setTimeout(() => {
        setShowLoader(false);
      }, 5200); // MUST match CSS transition (5.2s)

      return () => clearTimeout(fadeTimer);
    }
  }, [loading]);

  return (
    <>
      {showLoader && <Preloader loading={loading} />}

      {!loading && (
        <div className="App" id="pagecontent">
          <TopPage />
          <Welcome />
          <Details />
          <RSVP />
          <Registry />
        </div>
      )}
      <ErrorMessage />
    </>
  );
}

export default App;
